import { useState, useEffect } from "react";
import "./creditCardForm.css";
import { useDispatch, useSelector } from "react-redux";
import {
  capturePciVault,
  checkOtpvallidity,
  crediCardCaptureAsync,
  sendOtpToUser,
  verifyCCToken,
  verifyEmailToken,
} from "../../redux/reducers/creditCard";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../components/loader/loader";
import Timer from "../../components/timer/timer";
import OtpVerificationPopup from "../../components/otpVerificationPopup/otpVerificationPopup";

export default function CreditCardForm() {
  const dispatch = useDispatch();
  const [number, setNumber] = useState("");
  const [timerEnded, setTimerEnded] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [showNotification, setNotifcation] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const url = useLocation();
  const params = new URLSearchParams(url.search);
  const tokenparam = params.get("token");
  const orderparam = params.get("orderId");
  const {
    send_otp,
    valid_otp,
    loading,
    pciVaultResonse,
    error,
    otp_error,
    phone_number,
  } = useSelector((state) => state.creditCard);

  const navigate = useNavigate();
  const handleOnClose = () => setIsOpen(false);
  const handleTwoFA = (e) => {
    e.preventDefault();

    dispatch(
      checkOtpvallidity({
        orderId: orderparam,
        otp: number,
      })
    )
      .then((resp) => {
        const message = resp.payload;

        if (message === "Invalid OTP") {
          setErrorMessage("The OTP you entered is invalid. Please try again.");
          setShowError(true);
        } else if (message === "OTP expired") {
          setErrorMessage("The OTP has expired. Please request a new one.");
          setShowError(true);
        }

        // Clear the error message after 5 seconds
        const timer = setTimeout(() => {
          setShowError(false);
          setErrorMessage(""); // Reset the error message
        }, 5000);

        // Cleanup the timer
        return () => clearTimeout(timer);
      })
      .catch((err) => console.error(err));
  };

  const resendOtp = (e) => {
    e.preventDefault();
    dispatch(sendOtpToUser({ orderId: orderparam }))
      .then((resp) => {
        setTimerEnded(false);
        resp?.payload?.message === "OTP SENT" &&
          (setNotifcation(true), setTimeout(() => setNotifcation(false), 5000));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (tokenparam && orderparam) {
      dispatch(
        verifyEmailToken({ tokenparam: tokenparam, orderparam: orderparam })
      )
        .then((resp) => {
          resp.payload.success === true && setIsOpen(true);
        })
        .catch((err) => console.log(err));
    } else {
      navigate("/page-not-found");
    }
  }, []);

  useEffect(() => {
    // Load the CSS and JS script dynamically
    const loadPciVault = (url, secret) => {
      // Add stylesheet link
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://api.pcivault.io/pcd/pcd_form.css";
      document.head.appendChild(link);
      // Add script tag
      const script = document.createElement("script");
      script.src = "https://api.pcivault.io/pcd/pcd_form.js";
      script.defer = true;
      // On script load, initialize the form
      script.onload = () => {
        const orderparam = params.get("orderId");
        if (window.pcd_form) {
          window.pcd_form(document.getElementById("pcd_form"), {
            submit_secret: secret,
            submit_url: url,
            success_callback: (resp) => {
              dispatch(
                verifyCCToken({
                  tokenparam: `${resp.reference}-${resp.token}`,
                  orderparam: orderparam,
                  uniqueid: orderparam,
                })
              );
            },
          });
        }
      };
      document.body.appendChild(script);
      // Cleanup on unmount
      return () => {
        document.head.removeChild(link);
        document.body.removeChild(script);
      };
    };
    if (valid_otp?.message === "VALID OTP" && valid_otp?.token) {
      dispatch(
        capturePciVault({ token: valid_otp?.token, orderId: orderparam })
      )
        .then((resp) => {
          resp.payload.url && resp.payload.secret
            ? loadPciVault(resp.payload.url, resp.payload.secret)
            : navigate("/page-not-found");
        })
        .catch((err) => console.log(err));
      setTimeout(
        () =>
          document.getElementById("cardName")?.setAttribute("maxlength", 24),
        1000
      );
    }
  }, [valid_otp]);

  useEffect(() => {
    pciVaultResonse && navigate("/credit-card-submit-success");
    error && navigate("/page-not-found");
  }, [pciVaultResonse, error]);

  // Callback function to handle timer end event
  const handleTimerEnd = (hasEnded) => {
    setTimerEnded(hasEnded);
  };

  useEffect(() => {
    if (send_otp?.resend_time) {
      setTimeLeft(send_otp?.resend_time * 60 * 1000);
    }
  }, [send_otp]);

  return (
    <div id="pcd_form">
      <Loader loading={loading} />
      {valid_otp?.message === "VALID OTP" ? (
        <p>
          Unlock affordable, flexible mobile plans with Optimum Mobile. Whether
          you're looking for unlimited data or a pay-per-gig option, Optimum has
          plans to suit every need, starting as low as $15/month.
        </p>
      ) : (
        !loading && (
          <>
            {isOpen && (
              <OtpVerificationPopup
                onClose={handleOnClose}
                sendOtp={resendOtp}
                phone_number={phone_number}
              />
            )}
            <div className="two-FA-auth" onSubmit={handleTwoFA}>
              <h1>2-Factor Authentication</h1>
              <p>Enter OTP</p>
              <input
                value={number}
                onChange={(e) => setNumber(e.currentTarget.value)}
              />
              {showError && errorMessage && (
                <p className="error">{errorMessage}</p>
              )}
              <button type="button" onClick={handleTwoFA} className="btn">
                Submit
              </button>
              {!timerEnded && !otp_error && (
                <Timer
                  timeLeft={timeLeft}
                  setTimeLeft={setTimeLeft}
                  onTimerEnd={handleTimerEnd}
                />
              )}

              {!otp_error && timerEnded && (
                <button
                  className="resend-otp"
                  type="button"
                  onClick={(e) => resendOtp(e)}
                >
                  Resend Otp
                </button>
              )}
              {showNotification && (
                <p className="notification">
                  OTP has been sent to your registered mobile number.
                </p>
              )}
              {otp_error && (
                <p className="limit-reached">
                  You've reached the maximum number of OTP resends. For help,
                  please reach out to our support team.
                </p>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
}
